import { connect } from 'react-redux';
import { PlansSelector } from '../../redux/reducers/PlansReducer';
import { HomeSelector } from '../../redux/reducers/HomeReducer';
import Summary from '../../components/payment/Summary/Summary';
import { ConfigSelector } from '../reducers/ConfigReducer';
import { PaymentSelector } from '../reducers/PaymentReducer';

// TODO should have a StateManager object which contains all information about the state
const mapStateToProps = state => ({
  firstName: PaymentSelector.getGivenName(state),
  lastName: PaymentSelector.getSurname(state),
  email: PaymentSelector.getEmail(state),
  contactNumber: PaymentSelector.getContactNumber(state),
  connectionDate: PaymentSelector.getConnectionDate(state),
  preferredDate: PaymentSelector.getPreferredDate(state),
  modemDelivery: PaymentSelector.getModemDelivery(state),
  modemName: PaymentSelector.getModemName(state),
  modemCompany: PaymentSelector.getModemCompany(state),
  modemAddress: PaymentSelector.getModemAddress(state),
  modemSuburb: PaymentSelector.getModemSuburb(state),
  modemCity: PaymentSelector.getModemCity(state),
  modemPostcode: PaymentSelector.getModemPostcode(state),
  modemDeliveryInstructions: PaymentSelector.getModemDeliveryInstructions(state),
  selectedAddressParts: HomeSelector.getSelectedAddressParts(state),
  selectedPlan: PlansSelector.getSelectedPlan(state),
  basePrice: PlansSelector.getBasePrice(state),
  technologyType: PlansSelector.getTechnologyType(state),
  contractType: PlansSelector.getContractType(state),
  discountWithSubscription: ConfigSelector.getDiscountWithSubscription(state),
  withMobileDiscount: PlansSelector.checkWithMobileDiscount(state),
  isContractSelected: PlansSelector.getIsContractSelected(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
  byoModemDiscountPrice: PlansSelector.getByoModemDiscountPrice(state),
});

const SummaryContainer = connect(mapStateToProps)(Summary);

export default SummaryContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/SummaryContainer.js
 **/